
/**
 * Deep copies given object, through all known iterables.
 *
 * @param  {*} obj
 * @return {*}
 */
export default function deepCopy (obj) {
  if (this.isIterable(obj)) {
    return this.copyGenerator(obj,
      function *(yieldable, entries) {
        for (let [key, value] of entries) {
          yield yieldable(this.deepCopy(key), this.deepCopy(value));

        }
      }
    );
  } else {
    return this.valueCopy(obj);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/deepCopy.js